/* SKINGRAPHICA redesign. Academy and ICONICA articles: gathers the article into the reading column, builds the contents, reading time and progress line, and places the product note at the natural midpoint. Generated */
(function () {
  'use strict';
  var ROOTS = '.sg-academy,.iconica-wrapper,.iconica-breathingroom,.iconica-stilllife,.iconica-indelible,.iconica-landing';
  function vis(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }
  function slug(t) { return t.toLowerCase().replace(/[’'"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60); }
  function init() {
    var top = document.querySelector('[data-sga]');
    if (!top) return;
    var col = top.querySelector('[data-sga-col]');
    var main = document.getElementById('MainContent');
    if (!col || !main) return;
    /* gather every section that carries the article itself */
    Array.prototype.forEach.call(main.querySelectorAll(':scope > .shopify-section, :scope > div > .shopify-section'), function (s) {
      if (s.contains(top) || s.querySelector('[data-sga-end]')) return;
      if (s.querySelector(ROOTS)) col.appendChild(s);
    });
    if (!col.children.length) { top.classList.add('sga-empty'); document.documentElement.classList.add('sga-ready'); return; }
    /* contents from the article's headings */
    function pick(sel) { return Array.prototype.filter.call(col.querySelectorAll(sel), function (h) { return vis(h) && h.textContent.trim().length > 2 && !h.closest('.sga-note'); }); }
    var hs = pick('h2');
    if (hs.length < 3) { var h3s = pick('h3'); if (h3s.length >= 3) { hs = h3s; hs.forEach(function (h) { h.classList.add('sga-sec'); }); } }
    var used = {};
    var items = hs.map(function (h) {
      var main = h.querySelector('.sg-academy-h2-main');
      var t = (main ? main.textContent : h.textContent).replace(/\s+/g, ' ').trim();
      if (!h.id) { var id = slug(t) || 'section'; while (used[id] || document.getElementById(id)) id += '-2'; h.id = id; }
      used[h.id] = 1;
      return { id: h.id, t: t };
    });
    if (items.length >= 3) {
      var toc = top.querySelector('[data-sga-toc]'), ol = toc && toc.querySelector('ol');
      var html = items.map(function (it) { return '<li><a href="#' + it.id + '" data-for="' + it.id + '">' + it.t.replace(/</g, '&lt;') + '</a></li>'; }).join('');
      if (ol) { ol.innerHTML = html; toc.hidden = false; }
      var m = document.createElement('details');
      m.className = 'sga-toc-m';
      m.innerHTML = '<summary>On this page</summary><ol>' + html + '</ol>';
      col.parentNode.insertBefore(m, col);
      if ('IntersectionObserver' in window && toc) {
        var links = toc.querySelectorAll('a');
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            if (!en.isIntersecting) return;
            Array.prototype.forEach.call(links, function (l) { l.classList.toggle('on', l.getAttribute('data-for') === en.target.id); });
          });
        }, { rootMargin: '-15% 0px -75% 0px' });
        hs.forEach(function (h) { io.observe(h); });
      }
    }
    /* reading time */
    var words = (col.innerText || '').split(/\s+/).filter(Boolean).length;
    var rt = top.querySelector('[data-sga-rt]');
    if (rt && words > 120) { rt.textContent = Math.max(2, Math.round(words / 230)) + ' min read'; rt.hidden = false; }
    /* the product note, at the article's natural midpoint */
    var tpl = document.querySelector('template[data-sga-inline]');
    if (tpl && words > 400) {
      var at = null;
      if (hs.length >= 3) at = hs[Math.floor(hs.length * 0.45)];
      else { var ps = col.querySelectorAll('p'); if (ps.length > 6) at = ps[5].nextElementSibling; }
      if (at && at.parentNode) at.parentNode.insertBefore(tpl.content.cloneNode(true), at);
    }
    /* reading progress */
    var bar = document.createElement('div'); bar.className = 'sga-prog'; bar.setAttribute('aria-hidden', 'true'); document.body.appendChild(bar);
    var q = false;
    function prog() {
      q = false;
      var r = col.getBoundingClientRect(), h = r.height - window.innerHeight * 0.6;
      var p = h > 0 ? Math.min(1, Math.max(0, -r.top / h)) : 0;
      bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }
    window.addEventListener('scroll', function () { if (!q) { q = true; requestAnimationFrame(prog); } }, { passive: true });
    prog();
    document.documentElement.classList.add('sga-ready');
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
